import * as ambassadorWixEditorBranchesV1Branch from './editor-branches-v1-branch-branches.http.js';
import * as ambassadorWixEditorBranchesV1BranchTypes from './editor-branches-v1-branch-branches.types.js';
import * as ambassadorWixEditorBranchesV1BranchUniversalTypes from './editor-branches-v1-branch-branches.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createBranch(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEditorBranchesV1BranchUniversalTypes.CreateBranchRequest,
  ambassadorWixEditorBranchesV1BranchTypes.CreateBranchRequest,
  ambassadorWixEditorBranchesV1BranchUniversalTypes.CreateBranchResponse,
  ambassadorWixEditorBranchesV1BranchTypes.CreateBranchResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEditorBranchesV1Branch.createBranch(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/branches',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getBranch(): __PublicMethodMetaInfo<
  'GET',
  { branchId: string },
  ambassadorWixEditorBranchesV1BranchUniversalTypes.GetBranchRequest,
  ambassadorWixEditorBranchesV1BranchTypes.GetBranchRequest,
  ambassadorWixEditorBranchesV1BranchUniversalTypes.GetBranchResponse,
  ambassadorWixEditorBranchesV1BranchTypes.GetBranchResponse
> {
  const payload = { branchId: ':branchId' } as any;

  const getRequestOptions =
    ambassadorWixEditorBranchesV1Branch.getBranch(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/branches/{branchId}',
    pathParams: { branchId: 'branchId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateBranch(): __PublicMethodMetaInfo<
  'PATCH',
  { branchId: string },
  ambassadorWixEditorBranchesV1BranchUniversalTypes.UpdateBranchRequest,
  ambassadorWixEditorBranchesV1BranchTypes.UpdateBranchRequest,
  ambassadorWixEditorBranchesV1BranchUniversalTypes.UpdateBranchResponse,
  ambassadorWixEditorBranchesV1BranchTypes.UpdateBranchResponse
> {
  const payload = { branch: { id: ':branchId' } } as any;

  const getRequestOptions =
    ambassadorWixEditorBranchesV1Branch.updateBranch(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/branches/{branch.id}',
    pathParams: { branchId: 'branchId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteBranch(): __PublicMethodMetaInfo<
  'DELETE',
  { branchId: string },
  ambassadorWixEditorBranchesV1BranchUniversalTypes.DeleteBranchRequest,
  ambassadorWixEditorBranchesV1BranchTypes.DeleteBranchRequest,
  ambassadorWixEditorBranchesV1BranchUniversalTypes.DeleteBranchResponse,
  ambassadorWixEditorBranchesV1BranchTypes.DeleteBranchResponse
> {
  const payload = { branchId: ':branchId' } as any;

  const getRequestOptions =
    ambassadorWixEditorBranchesV1Branch.deleteBranch(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/branches/{branchId}',
    pathParams: { branchId: 'branchId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryBranches(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEditorBranchesV1BranchUniversalTypes.QueryBranchesRequest,
  ambassadorWixEditorBranchesV1BranchTypes.QueryBranchesRequest,
  ambassadorWixEditorBranchesV1BranchUniversalTypes.QueryBranchesResponse,
  ambassadorWixEditorBranchesV1BranchTypes.QueryBranchesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEditorBranchesV1Branch.queryBranches(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/branches/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setDefaultBranch(): __PublicMethodMetaInfo<
  'POST',
  { branchId: string },
  ambassadorWixEditorBranchesV1BranchUniversalTypes.SetDefaultBranchRequest,
  ambassadorWixEditorBranchesV1BranchTypes.SetDefaultBranchRequest,
  ambassadorWixEditorBranchesV1BranchUniversalTypes.SetDefaultBranchResponse,
  ambassadorWixEditorBranchesV1BranchTypes.SetDefaultBranchResponse
> {
  const payload = { branchId: ':branchId' } as any;

  const getRequestOptions =
    ambassadorWixEditorBranchesV1Branch.setDefaultBranch(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/branches/{branchId}/set-default',
    pathParams: { branchId: 'branchId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDefaultBranch(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEditorBranchesV1BranchUniversalTypes.GetDefaultBranchRequest,
  ambassadorWixEditorBranchesV1BranchTypes.GetDefaultBranchRequest,
  ambassadorWixEditorBranchesV1BranchUniversalTypes.GetDefaultBranchResponse,
  ambassadorWixEditorBranchesV1BranchTypes.GetDefaultBranchResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEditorBranchesV1Branch.getDefaultBranch(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/branches/default',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateBranchTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEditorBranchesV1BranchUniversalTypes.BulkUpdateBranchTagsRequest,
  ambassadorWixEditorBranchesV1BranchTypes.BulkUpdateBranchTagsRequest,
  ambassadorWixEditorBranchesV1BranchUniversalTypes.BulkUpdateBranchTagsResponse,
  ambassadorWixEditorBranchesV1BranchTypes.BulkUpdateBranchTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEditorBranchesV1Branch.bulkUpdateBranchTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/branches/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateBranchTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEditorBranchesV1BranchUniversalTypes.BulkUpdateBranchTagsByFilterRequest,
  ambassadorWixEditorBranchesV1BranchTypes.BulkUpdateBranchTagsByFilterRequest,
  ambassadorWixEditorBranchesV1BranchUniversalTypes.BulkUpdateBranchTagsByFilterResponse,
  ambassadorWixEditorBranchesV1BranchTypes.BulkUpdateBranchTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEditorBranchesV1Branch.bulkUpdateBranchTagsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/branches/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Branch as BranchOriginal,
  BranchSourceOneOf as BranchSourceOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  SourceType as SourceTypeOriginal,
  SourceTypeWithLiterals as SourceTypeWithLiteralsOriginal,
  EditorType as EditorTypeOriginal,
  EditorTypeOptions as EditorTypeOptionsOriginal,
  EditorTypeOptionsWithLiterals as EditorTypeOptionsWithLiteralsOriginal,
  SourceBranch as SourceBranchOriginal,
  SourceTemplate as SourceTemplateOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  PublicTags as PublicTagsOriginal,
  TagList as TagListOriginal,
  TagsModified as TagsModifiedOriginal,
  CreateBranchRequest as CreateBranchRequestOriginal,
  CreateBranchResponse as CreateBranchResponseOriginal,
  GetBranchRequest as GetBranchRequestOriginal,
  GetBranchResponse as GetBranchResponseOriginal,
  UpdateBranchRequest as UpdateBranchRequestOriginal,
  UpdateBranchResponse as UpdateBranchResponseOriginal,
  DeleteBranchRequest as DeleteBranchRequestOriginal,
  DeleteBranchResponse as DeleteBranchResponseOriginal,
  QueryBranchesRequest as QueryBranchesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryBranchesResponse as QueryBranchesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  HtmlSitePublished as HtmlSitePublishedOriginal,
  Page as PageOriginal,
  Empty as EmptyOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  SetDefaultBranchRequest as SetDefaultBranchRequestOriginal,
  SetDefaultBranchResponse as SetDefaultBranchResponseOriginal,
  GetDefaultBranchRequest as GetDefaultBranchRequestOriginal,
  GetDefaultBranchResponse as GetDefaultBranchResponseOriginal,
  BulkUpdateBranchTagsRequest as BulkUpdateBranchTagsRequestOriginal,
  BulkUpdateBranchTagsResponse as BulkUpdateBranchTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateBranchTagsResult as BulkUpdateBranchTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateBranchTagsByFilterRequest as BulkUpdateBranchTagsByFilterRequestOriginal,
  BulkUpdateBranchTagsByFilterResponse as BulkUpdateBranchTagsByFilterResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateBranchApplicationErrors as CreateBranchApplicationErrorsOriginal,
  UpdateBranchApplicationErrors as UpdateBranchApplicationErrorsOriginal,
  DeleteBranchApplicationErrors as DeleteBranchApplicationErrorsOriginal,
  BulkUpdateBranchTagsApplicationErrors as BulkUpdateBranchTagsApplicationErrorsOriginal,
  BulkUpdateBranchTagsByFilterApplicationErrors as BulkUpdateBranchTagsByFilterApplicationErrorsOriginal,
} from './editor-branches-v1-branch-branches.types.js';
